@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.confirmation-modal {
  width: 1000px;
  margin: 30px 0;
}

.confirmation-modal-body {
  padding: 15px;
  font-size: 13px;
  line-height: 1.42;
  color: @product-page--inventory-modal--text-color;
}

.inventory-import-select-button {
  padding: 0 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    display: none;
  }
}

.inventory-import-pill {
  padding: 0 18px;
  color: @product-page--inventory-pill--text-color;
}

.inventory-import-file-extension-error {
  color: @product-page--inventory-pill--error--text-color;
  margin-left: 10px;
}

.warehouse-dropdown-picker {
  margin-bottom: 20px;
}

.combine-button {
  display: flex;

  .combine {
    width: 15px;
    height: 15px;
    margin: auto 5px auto 0;
  }
}

.button-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.checkbox-postlabel {
  display: block;
  margin-top: 5px;
}
